import React from "react";
import styled from "@emotion/styled";
import { SMALL_DEVICES } from "../../../mediaQueries";

const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: fit-content;

  ${SMALL_DEVICES} {
    flex-direction: column;
    align-items: center;
  }
`;

const Image = styled.img`
  height: 300px;
  object-fit: contain;
  margin-right: 20px;

  ${SMALL_DEVICES} {
    width: 200px;
  }
`;

const InformationContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const Name = styled.div`
  font-size: 34px;
  color: white;
`;

const Title = styled.div`
  font-size: 26px;
  color: #85d3e0;
  margin-bottom: 20px;
  font-weight: lighter;
`;

const Description = styled.div`
  font-size: 18px;
  color: #ccc;
  font-weight: lighter;
`;

interface Props {
  image: string;
  name: string;
  title: string;
  description: string;
}

export const TeamItem: React.FC<Props> = (props) => {
  return (
    <Container>
      <Image src={props.image} />
      <InformationContainer>
        <Name>{props.name}</Name>
        <Title>{props.title}</Title>
        <Description>{props.description}</Description>
      </InformationContainer>
    </Container>
  );
};
